var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmployment(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 15,
    viewBox: "0 0 18 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_695_854)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5625 6.625C11.3862 6.625 9.625 8.38621 9.625 10.5625C9.625 12.7388 11.3862 14.5 13.5625 14.5C15.7388 14.5 17.5 12.7388 17.5 10.5625C17.5 8.38621 15.7388 6.625 13.5625 6.625ZM15.3125 10.7345C15.3125 10.8805 15.193 11 15.047 11H13.3908C13.2448 11 13.1253 10.8805 13.1253 10.7345V8.64078C13.1253 8.49477 13.2448 8.37527 13.3908 8.37527H13.7345C13.8805 8.37527 14 8.49477 14 8.64078V10.125H15.047C15.193 10.125 15.3125 10.2445 15.3125 10.3905V10.7345ZM13.5625 5.75C13.7102 5.75 13.8556 5.75902 14 5.77215V4.4375C14 3.7375 13.3875 3.125 12.6875 3.125H10.5V1.8125C10.5 1.1125 9.8875 0.5 9.1875 0.5H4.8125C4.1125 0.5 3.5 1.1125 3.5 1.8125V3.125H1.3125C0.6125 3.125 0 3.7375 0 4.4375V6.625H10.8041C11.5861 6.07566 12.5363 5.75 13.5625 5.75ZM8.75 3.125H5.25V2.25H8.75V3.125ZM8.93648 9.25H5.6875C5.44578 9.25 5.25 9.05422 5.25 8.8125V7.5H0V11.4375C0 12.1375 0.6125 12.75 1.3125 12.75H9.28129C8.94414 12.0927 8.75 11.3505 8.75 10.5625C8.75 10.107 8.81781 9.66781 8.93648 9.25Z",
    fill: "url(#paint0_linear_695_854)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_695_854",
    x1: 17.5,
    y1: 13.45,
    x2: 6.06684,
    y2: -1.37076,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#383BF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6769FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_695_854"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.5,
    height: 14,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmployment);
export default __webpack_public_path__ + "static/media/employment.d5791c474c8eefc79704abeb2c7648e3.svg";
export { ForwardRef as ReactComponent };